import Dexie from 'dexie';
import { Injectable } from '@angular/core';
import { AuthModel, IUserRoleModel } from '../models/auth.model';
import { AppDatabaseService } from './app-database.service';

@Injectable({
  providedIn: 'root',
})
export class UsersStorageService {
  users: Dexie.Table<AuthModel, number>;
  active_user: Dexie.Table<AuthModel, number>;

  constructor(private appDatabaseService: AppDatabaseService) {
    this.users = this.appDatabaseService.table('users');
    this.active_user = this.appDatabaseService.table('active_user');
  }
  async saveUser(user: AuthModel, action: 'update' | 'create'): Promise<void> {
    return this.appDatabaseService.transaction(
      'rw',
      this.active_user,
      this.users,
      async () => {
        await this.active_user.clear();
        const activeUser = new AuthModel({
          ...user,
        });
        await this.active_user.put(activeUser);
        if (action === 'create') {
          await this.users.put(user);
        } else {
          await this.users.update(user.id, user);
        }
      }
    );
  }

  async updateUser(userId: number, data: unknown): Promise<void> {
    return this.appDatabaseService.transaction(
      'rw',
      this.users,
      this.active_user,
      async () => {
        await this.active_user.update(userId, data);
        await this.users.update(userId, data);
      }
    );
  }

  async getUser(id: number): Promise<AuthModel> {
    const user = await this.users.get(id);
    return user;
  }

  async getActiveUser(): Promise<AuthModel> {
    return this.appDatabaseService.transaction(
      'r',
      this.active_user,
      async () => {
        const activeUser = await this.active_user.toArray();
        return activeUser.length > 0 ? activeUser[0] : null;
      }
    );
  }

  async deleteActiveUser(id: number): Promise<void> {
    if (!id) {
      return;
    }
    return this.appDatabaseService.transaction(
      'rw',
      this.active_user,
      this.users,
      async () => {
        await this.active_user.clear();
        await this.users.update(id, {
          access_token: null,
          refresh_token: null,
        });
      }
    );
  }

  async getAuthState(): Promise<{
    users: AuthModel[];
    activeUser: AuthModel;
  }> {
    return this.appDatabaseService.transaction(
      'r',
      this.users,
      this.active_user,
      async () => {
        const users = await this.users.toArray();
        const activeUser = await this.active_user.toArray();

        return {
          users,
          activeUser: activeUser.length > 0 ? activeUser[0] : null,
        };
      }
    );
  }

  async updateUserPermissions(userId: number, role: IUserRoleModel): Promise<void> {
    return this.appDatabaseService.transaction('rw', this.users, async () => {
      const roleData = { role };
      await this.users.update(userId, roleData);
    });
  }
}
